import React, {useEffect} from "react";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import {Amplify} from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import awsconfig from "./modified_aws-export";
import {useTranslation} from "react-i18next";
import {Outlet} from "react-router-dom";
import tecAllianceLogo from "./assets/TecAlliance-Logo-Web.svg";
import {useAuthentication} from "./hooks";
import {AuthState} from "./store";
import Navigation from "./features/Navigation/Navigation";
import AppNavbar from "./features/AppNavbar/AppNavbar";
import {Footer} from "./features";

Amplify.configure(awsconfig);

const App: React.FC = () => {
  const {authState, authInitialized, initializeAuthentication, signIn} = useAuthentication();
  const { t } = useTranslation();

  useEffect(() => {
    if (!authInitialized) {
      initializeAuthentication();
    }
  }, [authInitialized, initializeAuthentication]);

  useEffect(() => {
    document.title = t("Title_landing_page");
  }, [t]);

  return (
    <>
      <div className="App">
        <AppNavbar/>
        <Navigation/>
        <main className="login-container">
          {authState === AuthState.SignedIn ? (
              <Outlet/>
          ) : (
            <div className="unauth-container">
              <div className="unauth-wrapper">
                <img src={tecAllianceLogo} alt="tecalliance-logo" />
                <hr />
                <span>
                  Welcome! You are not signed in yet. Please click{" "}
                  <span className="hyper-link" onClick={signIn}>
                    {t("Login")}
                  </span>{" "}
                  or use the login button in the top-right corner to sign in.
                </span>
              </div>
            </div>
          )}
        </main>

        <Footer />
      </div>

      <ToastContainer position="top-center" />
    </>
  );
};

export default App;
